import * as types from './types';

export default {
    [types.SET_STATE]: (state, payload) => payload,
    [types.UPDATE_STRINGS]: (state, payload) => ({
        ...state,
        strings: { ...state.strings, ...payload },
    }),
};
